import { createContext, useContext } from 'react'

const AllergenSheetContext = createContext<(() => void) | undefined>(undefined)

export const AllergenSheetProvider = AllergenSheetContext.Provider

export const useAllergenSheet = () => useContext(AllergenSheetContext)
